<template>
  <div v-loading="loding" :element-loading-text=" language('forgetPassword.placeholder5')">
    <div>
      <!-- <el-card class="login-form" shadow="never"> -->
      <div class="form_wrap">
        <el-form
          :model="loginForm"
          :rules="rules"
          status-icon
          ref="ruleForm"
          class="form"
        >
          <el-form-item prop="oldPassword">
            <el-input
              v-model="loginForm.oldPassword"
              :width="100"
              type="password"
              :placeholder="language('forgetPassword.placeholderOldPassword')"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              type="password"
              v-model="loginForm.password"
              :width="100"
              :placeholder="language('forgetPassword.placeholderNewPassword')"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password2">
            <el-input
              type="password"
              v-model="loginForm.password2"
              :width="100"
              :placeholder="language('forgetPassword.placeholderNewPassword2')"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              style="width: 100%"
              @click="doForgetPassword"
              >{{ language("forgetPassword.submit") }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <!-- </el-card> -->
    </div>
  </div>
</template>

<script>
const checkPassword = require("../rules/checkPassword.js").mixin;
export default {
  mixins: [checkPassword],
  data() {
    return {
      loding: false,
      loginForm: {
        password: "",
        password2: "",
        oldPassword: "",
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: this.language("forgetPassword.rulesOldPassword"),
            trigger: "click",
          },
        ],
        password: [
          {
            required: true,
            message: this.language("forgetPassword.rulesPassword"),
            trigger: "click",
          },
          { validator: this.checkPasswordOne, trigger: "blur" },
        ],
        password2: [
          {
            required: true,
            message: this.language("forgetPassword.rulesPassword"),
            trigger: "click",
          },
          { validator: this.checkPasswordTwo, trigger: "blur" },
        ],
      },
    };
  },
  watch: {},
  computed: {
    appTheme: function () {
      return this.$store.state.appData.appTheme;
    },
  },
  methods: {
    checkPasswordOne(rule, value, callback) {
      let text = this.checkPassword(this.loginForm.password);
      if (text != "") {
        callback(new Error(text));
      } else {
        callback();
      }
    },
    checkPasswordTwo(rule, value, callback) {
      let text = this.checkPasswordSame(
        this.loginForm.password,
        this.loginForm.password2,
        this.loginForm.oldPassword
      );
      if (text != "") {
        callback(new Error(text));
      } else {
        callback();
      }
    },
    doForgetPassword() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.loding = true;
          let data = {
            oldPassword: this.loginForm.oldPassword,
            newPassword1: this.loginForm.password,
            newPassword2: this.loginForm.password2,
          };

          oauthSDK
            .changePassword(data)
            .then((res) => {
              this.loding = false;
              this.$message.success(this.language("forgetPassword.success"));
              // this.replacePage({ url: "login", query: {} });
              this.replacePage({ url: this.$urlData.logoutURL, query: {} });
            })
            .catch((err) => {
              this.user401(err);
              this.defalutToast(err.message);
              this.loding = false;
            });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style lang="scss"  scoped>
.form_wrap {
  width: 80%;
  margin: 0 auto;
}

.login-form {
  width: 600px;
  height: 390px;
}
</style>